import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Alert from '@cloudscape-design/components/alert';
import Button from '@cloudscape-design/components/button';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import api from '../services/apiService';

export default function RequestVerificationPage() {
  const { token } = useParams();
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [expired, setExpired] = useState(false);
  const [resending, setResending] = useState(false);
  const [resendMessage, setResendMessage] = useState('');

  async function verify() {
    setSubmitting(true);
    setError('');
    setExpired(false);
    try {
      const response = await api.post(`/requests/verify/${token}`);
      setResult(response.data);
    } catch (requestError) {
      setExpired(requestError.response?.data?.code === 'verification_expired');
      setError(requestError.response?.data?.error || 'Die Anfrage konnte momentan nicht bestätigt werden.');
    } finally {
      setSubmitting(false);
    }
  }

  async function resend() {
    setResending(true);
    setResendMessage('');
    try {
      const response = await api.post(`/requests/verification/${token}/resend`);
      setResendMessage(response.data.message);
    } catch (requestError) {
      setError(requestError.response?.data?.error || 'Die Bestätigungs-E-Mail konnte nicht erneut angefordert werden.');
    } finally {
      setResending(false);
    }
  }

  if (result) {
    const processing = result.status === 'distribution_processing';
    return (
      <div className="form-shell">
        <Alert
          type={processing ? 'info' : 'success'}
          header={processing ? 'Anfrage wird bereits verteilt' : `Anfrage ${result.reference} bestätigt`}
        >
          {processing
            ? 'Die Bestätigung wurde bereits verarbeitet. Die Weiterleitung an passende Vermieter läuft.'
            : result.matchedTenantCount > 0
              ? `Ihre Anfrage wurde an passende Vermieter weitergeleitet. Sie erhalten bis zu ${result.desiredOfferCount} anonyme Preisinformationen per E-Mail.`
              : 'Ihre E-Mail-Adresse wurde bestätigt. Ihre Anfrage ist bei uns eingegangen.'}
        </Alert>
      </div>
    );
  }

  return (
    <div className="form-shell">
      <Container header={<Header variant="h1">Mietanfrage bestätigen</Header>}>
        <SpaceBetween size="l">
          <p>
            Bestätigen Sie jetzt Ihre E-Mail-Adresse. Erst danach ermittelt SmartRent passende Vermieter und leitet Ihre Anfrage weiter.
          </p>
          {error && <Alert type="error">{error}</Alert>}
          {resendMessage && <Alert type="success">{resendMessage}</Alert>}
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="primary" loading={submitting} disabled={Boolean(resendMessage)} onClick={verify}>
              Anfrage bestätigen und weiterleiten
            </Button>
            {expired && (
              <Button loading={resending} onClick={resend}>
                Neuen Bestätigungslink anfordern
              </Button>
            )}
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </div>
  );
}
